import {observable} from 'mobx';
//axios
import axios from 'axios';
//store
import profile from './profile';
import config from '../config';
import prompt from './prompt';
import panels from './panels';



class Widget{
  @observable toggleButton ={
    state: true,
  }
  @observable loading = false;
  @observable error = false;
  pushState(eventName,property,status){
    var self = this;
    axios.post(`//${config.env.server}/iot/data/apikey/${profile.apiKey}/event/${eventName}`,{
      [property]:status
    })
    .then(function(response){
      //Disappear Loading
      self.loading = false;
      //Replace data on Panels store
      panels.list.map(function(x,y){
        if(x.eventName === eventName){
          let arrayLength = panels.list[y].data.length;
          if(arrayLength === 0){
            panels.list[y].data[0][property] = status;
          }else{
            panels.list[y].data[arrayLength - 1][property] = status;
          }
        }
      })
    })
    .catch(function(err){
      if(err.response.status === 429){
        prompt.message('太頻繁，請稍後再試。');
        self.loading = false;
      }
    })
  }
  // syncData(eventName,property,status){
  //   this.toggleButton.state = status;
  // }
}
var widget = new Widget;

export default widget;



// WEBPACK FOOTER //
// ./src/store/widget.js